import * as React from 'react';
import { withTranslation } from '@i18n';
import { RatingStar } from '@images/svg/index';
import { BulletList } from '@components/index';

import {
  StyledCardWrapper,
  StyledImageWrapper,
  StyledRightWrapper,
  StyledHeadline,
  StyledRatingWrapper,
  StyledSubtitle,
  StyledDescription
} from './styles';
import { StyledGridUnit, StyledGridWrapper } from '../../../../Profile/ProfilePackages/styles';

const AccomodationCard = ({ t, packageData, relationshipData }) => {
  let amenetiesData = relationshipData?.accommodation?.data?.attributes.ameneties || ' ';
  amenetiesData = amenetiesData.replace(/\\n/g, '\n');
  const star = parseInt(relationshipData?.accommodation?.data?.attributes.rating, 10);
  let Rating = new Array(star) || 3;
  Rating = Rating.fill();
  return (
    <StyledCardWrapper>
      <StyledGridWrapper>
        <StyledGridUnit size={{ mobile: 1 / 1, desktop: 1 / 2 }}>
          <StyledImageWrapper>
            <img
              src={relationshipData?.accommodation?.data?.attributes.cover_image_url}
              alt={relationshipData?.accommodation?.data?.attributes.name}
            />
          </StyledImageWrapper>
        </StyledGridUnit>
        <StyledGridUnit size={{ mobile: 1 / 1, desktop: 1 / 2 }}>
          <StyledRightWrapper>
            <StyledHeadline>
              {relationshipData?.accommodation?.data?.attributes.name}
            </StyledHeadline>
            <StyledRatingWrapper>
              {Rating.map(() => (
                <RatingStar />
              ))}
            </StyledRatingWrapper>
            <StyledSubtitle>{t('AccomodationCard.LengthOfStay')}</StyledSubtitle>
            <StyledDescription>
              {t('Days', { noOfDays: packageData.data.attributes.days_in_hotel })}
            </StyledDescription>
            <StyledSubtitle>{t('AccomodationCard.Amenties')}</StyledSubtitle>
            <StyledDescription>
              <BulletList bullets={amenetiesData.split('\n')} />
            </StyledDescription>
          </StyledRightWrapper>
        </StyledGridUnit>
      </StyledGridWrapper>
    </StyledCardWrapper>
  );
};

export default withTranslation('ProfilePackages')(AccomodationCard);
